import { render, staticRenderFns } from "./SearchSale.vue?vue&type=template&id=460e9e9c&scoped=true&"
import script from "./SearchSale.vue?vue&type=script&lang=js&"
export * from "./SearchSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460e9e9c",
  null
  
)

export default component.exports